import React from 'react';
import { StatCard } from '../shared';

interface WidgetCallsProps {
  callCount: number;
  distinctPropertyCount: number;
  propertiesBelowThreshold: number;
}

export const WidgetCalls: React.FC<WidgetCallsProps> = ({
  callCount,
  distinctPropertyCount,
  propertiesBelowThreshold
}) => (
  <>
    <StatCard
      label="Total Calls"
      value={callCount}
      subValue={`${distinctPropertyCount} properties`}
    />
    <StatCard
      label="Properties Below 70"
      value={propertiesBelowThreshold}
      color={propertiesBelowThreshold > 0 ? '#ef4444' : '#22c55e'}
    />
  </>
);
